<template>
    <div class="establishModalWrap">
        <div class="mask" @click="closeModal"></div>
        <div class="establishBox">
           <div class="title">申请打款审核</div>
           <div class="oneArea">
             <!-- <div v-if="isLiquidation">
                这里是清算的申请
              </div> -->
              <div class="oneline"><span class="mylabel">申请金额</span><span class="text">{{infoObj.request_amount}}元</span></div>
              <div class="oneline"><span class="mylabel">申请时间</span><span class="text">{{infoObj.request_submit_time}}</span></div>
              <div class="oneline"><span class="mylabel">提交凭证 </span>
                <template v-for="(img_ele, img_index) in infoObj.imgArr">
                     <el-image style="width: 100px; height: 100px"
                       :key="img_index"
                       v-if="img_ele"
                       class="img"
                       :src="img_ele"
                       fit="cover"
                       :preview-src-list="infoObj.imgArr"
                   ></el-image>
                 </template>



              </div>
              <div class="oneline"><span class="mylabel">申请说明</span><span class="text">{{infoObj.request_content}}</span></div>
           </div>
           <div class="oneArea">
               <div class="oneline">
                   <span class="mylabel"><i class="redStar">*</i> 审核结果</span>
                   <el-radio v-model="result" label="y">通过</el-radio>
                   <el-radio v-model="result" label="n">拒绝</el-radio>
                   <!-- <el-radio v-model="result" label="p">待审核</el-radio> -->
               </div>
               <div class="oneline" v-show="result=='n'">
                 <el-input
                   type="textarea"
                   :rows="3"
                   placeholder="请输入拒绝的理由(非必填)"
                   v-model="memo">
                 </el-input>
               </div>

           </div>
           <div class="footer">
               <button class="closeBtn btn" @click="closeModal">取消</button>
               <button class="submitBtn btn" @click="submitClick">确定</button>
           </div>
       </div>

    </div>
</template>

<script>
    import { ajaxPost, api } from "@/common/request.js";
    import { json, wordData, utils } from "@/common/common.js";

    export default {
      name: 'components',
      props: ["info","isLiquidation"],
      computed: {
        infoObj(){
          console.log(this.info)
            return this.info
        },
        adminId() {
          return utils.getAdminId()
        },
      },
      data () {
        return {
            result:"",
            memo:'',
        }
      },
      watch: {
      },
      methods: {
          closeModal(){
              this.$emit("close")
              this.memo=''
              this.result=''
          },
          closeModalAndSuccess(){
              this.$emit("success")
              this.memo=''
              this.result=''
          },
          submitClick(){
              let _this=this
              let arg={}
              if(!this.isLiquidation){//是下单阶段的审核；
                arg={
                  requestId:_this.infoObj.request_id,
                  adminId:this.adminId,
                  requestLastUpdateMemo:_this.memo,
                  requestState:_this.result,
                  purchaseOrderId:_this.infoObj.parent_order_id,
                }

              }else{//清算阶段的审核
                arg={
                  requestId:_this.infoObj.request_id,
                  adminId:this.adminId,
                  requestLastUpdateMemo:_this.memo,
                  requestState:_this.result,
                  liquidateOrderId:_this.infoObj.parent_order_id,
                }
              }
              console.log(arg)
              if(!this.result){
                  this.$message.error('您还未选择审核结果')
              }else{
                  ajaxPost("/dwOrder/applicationReview",arg).then(res => {
                      if (res.errorCode == 200) {
                          this.$message.success(res.errorMsg || '操作成功')
                          this.closeModalAndSuccess()
                      } else {
                          this.$message.error(res.errorMsg || '操作失败')
                      }
                  }).catch(err => {
                      console.log(err)
                  })
              }
          }
      },
      mounted() {

      }
    }
</script>

<style scoped lang="scss">
.establishModalWrap{
    position: fixed;
    top:0;left:0;right:0;bottom:0;
    z-index:100;
    .mask{
        background:rgba(0,0,0,0.5);
        position: fixed;
        top:0;left:0;right:0;bottom:0;
    }
    .establishBox{
        position: fixed;z-index:1000;
        left:20%;top:15%;overflow-y: scroll;
        width: 60%;min-width: 700px; border:1px solid #eee;border-radius: 4px;
        background: #fff;border-radius: 2px;
        input{border:1px solid #ddd;border-radius: 4px;padding:8px;}
        .title{
            font-size: 18px;
            padding:19px 25px;
            border-bottom: 1px solid #eee;
        }
        .oneArea{margin:20px 0;}
        .oneline{margin:10px 0;padding:0 25px;
        }
        .mylabel{position: relative; display: inline-block;min-width: 60px;text-align-last: justify;margin-right: 20px;font-weight: bold;
          .redStar{position: absolute;left:-10px;top:0;}
        }
        .text{}

        .footer{
            text-align: right;
            border-top: 1px solid #eee;
            padding:14px 25px;
            .btn{padding:5px 16px;background: #fff;font-size: 12px;border-radius: 4px;}
            .closeBtn{margin-right: 10px;border:1px solid #D9D9D9;}
            .submitBtn{background: #F81D22;color:#fff;border:0;}
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/applyAuth.vue